<template>
    <BaseFileUpload
        v-slot="{ clickInput }"
        :is-multiple-file-upload-enabled="true"
        :accepted-file-types="acceptedFileTypes"
        :is-disabled="isUploading"
        :is-document-dropzone-enabled="true"
        @file-upload="(files: File[]) => emit('fileUpload', files)">
        <div class="border-2 border-dashed rounded-lgr p-6 text-center border-control-border hover:border-control-border-strong hover:bg-surface-hover transition-colors">
            <i class="bi bi-cloud-upload text-2xl text-ink-muted" aria-hidden="true"></i>
            <p class="body-small text-ink-muted mt-1">{{ t("profile.collaboration.documents.dropzone") }}</p>
            <BaseButton theme="neutral" size="sm" :disabled="isUploading" class="mt-2 inline-flex items-center gap-2 rounded-lgr" @click="clickInput">
                <LoadingSpinner v-if="isUploading" class="h-4 w-4" />
                {{ t("profile.collaboration.documents.browse") }}
            </BaseButton>
            <p class="details text-ink-muted mt-2">{{ t("profile.collaboration.documents.supportedTypes", { types: formatAcceptedFileTypes(acceptedFileTypes) }) }}</p>
        </div>
    </BaseFileUpload>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseFileUpload from "~vue/components/BaseFileUpload.vue";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { formatAcceptedFileTypes } from "~vue/utils/fileUpload";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineProps<{
    acceptedFileTypes: string;
    isUploading: boolean;
}>();

const emit = defineEmits<{ fileUpload: [files: File[]] }>();
</script>
